import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { formatDate } from '../../utils/helpers';

const SourceCard = ({ source, onSync }) => {
  const isHealthy = source.status === 'På';
  const isError = source.status === 'Feil';

  const getStatusColor = () => {
    if (isError) return 'bg-red-100 text-red-700 border-red-200';
    if (!isHealthy) return 'bg-slate-100 text-slate-500 border-slate-200';
    return 'bg-emerald-100 text-emerald-700 border-emerald-200';
  };

  return (
    <div className={`bg-white p-6 rounded-2xl border shadow-sm hover:shadow-md transition-all ${isError ? 'border-red-200 ring-1 ring-red-100' : 'border-slate-200'}`}>
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${isError ? 'bg-red-50 text-red-600' : isHealthy ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-400'}`}>
            <SafeIcon icon={isError ? "⚠️" : "📡"} />
          </div>
          <div>
            <h4 className="font-bold text-slate-900 text-sm">{source.name}</h4>
            <p className="text-xs text-slate-500">{source.provider_type}</p>
          </div>
        </div>
        <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase tracking-widest border ${getStatusColor()}`}>
          {source.status}
        </span>
      </div>
      
      <p className="text-xs text-slate-600 mb-4 line-clamp-2 h-8">
        {source.data_scope}
      </p>

      {source.notes && isError && (
        <div className="mb-4 p-2 bg-red-50 rounded-lg border border-red-100 text-[10px] text-red-800 font-medium flex items-center gap-2">
          <SafeIcon icon="ℹ️" /> {source.notes}
        </div>
      )}

      <div className="flex items-center justify-between pt-4 border-t border-slate-100">
        <span className="text-[10px] text-slate-400 font-bold">
          Sist sync: {source.last_ok_sync_at ? formatDate(source.last_ok_sync_at) : 'Aldri'}
        </span>
        <button 
          onClick={() => onSync(source.source_id)}
          className="p-2 bg-slate-50 hover:bg-primary-50 text-slate-500 hover:text-primary-600 rounded-lg transition-colors group"
          title="Kjør manuell sync"
        >
          <SafeIcon icon="🔄" className="w-4 h-4 group-active:rotate-180 transition-transform" />
        </button>
      </div>
    </div>
  );
};

export default SourceCard;